module.exports = __webpack_public_path__ + "public/img/img_fx.2a071490.png";